export const API_PROGRAMS = "v1/";
export const API_PROGRAM = "v1/education/program/:programId/user/:personalId";
export const API_PROGRAM_UNIT_REPORT = "v1/education/programs/unitstatsreport";
export const API_PROGRAM_TEAM_REPORT = "v1/education/programs/teamstatsreport";

export const API_PROGRAM_STATISTICS_UNITS =
  "v1/education/programs/unitstats/:unitId";
export const API_PROGRAM_STATISTICS_ADMIN =
  "v1/education/programs/statsforadmin";
export const API_PROGRAMREPORT_STATISTICS_UNITS =
  "v1/education/programs/unitstatsreport/:unitId";
export const API_PROGRAMREPORT_STATISTICS_ADMIN =
  "v1/education/programs/statsforadminreport/";
export const API_PROGRAM_STATISTICS_UNIT_STEPS =
  "v1/education/program/:courseObjectId/unitstats/:unitId";
export const API_PROGRAM_STATISTICS_UNIT_STEPS_PARTICIPANTS =
  "v1/education/program/:courseObjectId/userstats/:unitId";
export const API_PROGRAM_STATISTICS_TEAMS =
  "v1/education/programs/teamstats/:teamId";
export const API_PROGRAMREPORT_STATISTICS_TEAMS =
  "v1/education/programs/teamstatsreport/:teamId";
export const API_PROGRAM_STATISTICS_TEAM_STEPS =
  "v1/education/program/:courseObjectId/teamstats/:teamId";
export const API_PROGRAM_STATISTICS_TEAM_STEPS_PARTICIPANTS =
  "v1/education/program/:courseObjectId/teamuserstats/:teamId";
export const API_PROGRAM_STATISTICSFORADMIN_STEPS_PARTICIPANTS =
  "v1/education/program/:courseObjectId/userstatsforadmin";

export const API_PROGRAM_COURSE_ONLINE_STATUS =
  "v1/user/:personalId/coursestatus/:courseId";
export const API_PROGRAM_ACTIVITY = "v1/coworkeractivity/:activityId";
